import React, { useState, useEffect } from 'react';
import { Paginator } from 'primereact/paginator';

const JournalListing = ({ data, onEdit, onDelete, isLoading, sortConfig, requestSort }) => {
    const [first, setFirst] = useState(0);
    const rows = 20;

    useEffect(() => {
        setFirst(0);
    }, [data]);

    const paginatedData = data.slice(first, first + rows);

    const onPageChange = (event) => {
        setFirst(event.first);
    };

    const getSortIcon = (columnKey) => {
        if (!sortConfig || sortConfig.key !== columnKey) {
            return <i className="fa-solid fa-sort" style={{ color: '#ccc', marginLeft: '6px', fontSize: '13px' }}></i>;
        }
        return sortConfig.direction === 'asc'
            ? <i className="fa-solid fa-sort-up" style={{ color: '#0056b3', marginLeft: '6px', fontSize: '13px' }}></i>
            : <i className="fa-solid fa-sort-down" style={{ color: '#0056b3', marginLeft: '6px', fontSize: '13px' }}></i>;
    };

    return (
        <div
            className="table-card"
            style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                paddingBottom: '10px'
            }}
        >
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin fa-2x" style={{ color: '#3498db', marginBottom: '10px' }}></i>
                    <div style={{ color: '#666' }}>Đang tải dữ liệu</div>
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-newspaper" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Chưa có tạp chí nào</h3>
                </div>
            ) : (
                <>
                    <table className="custom-table" style={{ minWidth: '1300px' }}>
                        <thead>
                            <tr>
                                <th width="3%" style={{ textAlign: 'center' }}>STT</th>
                                <th
                                    width="25%"
                                    onClick={() => requestSort('Name')}
                                    style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                                    title="Nhấn để sắp xếp theo Tên tạp chí"
                                >
                                    TẠP CHÍ {getSortIcon('Name')}
                                </th>
                                <th width="12%">ISSN/ISBN</th>
                                <th width="15%">LOẠI TẠP CHÍ</th>
                                <th width="8%" style={{ textAlign: 'center' }}>ĐIỂM CT</th>
                                <th width="7%" style={{ textAlign: 'center' }}>ĐÃ DUYỆT?</th>
                                <th width="10%" style={{ textAlign: 'center' }}>THUỘC HĐCDGS</th>
                                <th width="10%" style={{ textAlign: 'center' }}>NGÀY TẠO</th>
                                <th width="10%">NGƯỜI TẠO</th>
                                <th width="5%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((item, index) => {
                                const actualIndex = first + index + 1;

                                return (
                                    <tr key={item.Id}>
                                        <td style={{ textAlign: 'center' }}>{actualIndex}</td>
                                        <td>
                                            <div
                                                style={{
                                                    fontWeight: '500',
                                                    color: '#0056b3',
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline'
                                                }}
                                                onClick={() => onEdit && onEdit(item)}
                                            >
                                                {item.Name}
                                            </div>
                                        </td>
                                        <td>{item.ISSN}</td>
                                        <td>{item.JournalTypeName}</td>
                                        <td style={{ textAlign: 'center', fontWeight: 'bold' }}>{item.Score}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            {item.IsApproved ? <i className="fa-solid fa-circle-check" style={{ color: '#2ecc71', fontSize: '16px' }}></i> : <i className="fa-solid fa-circle-xmark" style={{ color: '#e74c3c' }}></i>}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {item.IsHDCGS && <i className="fa-solid fa-circle-check" style={{ color: '#2ecc71', fontSize: '16px' }}></i>}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>{item.CreatedDate}</td>
                                        <td>{item.CreatorEmail}</td>
                                        <td>
                                            <div className="action-group" style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} style={{ cursor: 'pointer' }}>
                                                    <i className="fa-solid fa-pen edit-icon" style={{ color: '#3498db' }}></i>
                                                </div>
                                                <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} style={{ cursor: 'pointer' }}>
                                                    <i className="fa-solid fa-trash delete-icon" style={{ color: '#e74c3c' }}></i>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {data.length > rows && (
                        <div style={{ marginTop: '15px', borderTop: '1px solid #e9ecef', paddingTop: '10px' }}>
                            <Paginator
                                first={first}
                                rows={rows}
                                totalRecords={data.length}
                                onPageChange={onPageChange}
                                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                style={{ background: 'transparent', border: 'none' }}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default JournalListing;